import React from "react";
import classes from "./styles.module.scss";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { htmlToText } from "../../utils";

export default function CardSmall({ data }) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`article/${data?._id}`, { state: { data: data } });
  };

  return (
    <div onClick={handleClick} className={classes.CardBig}>
      <div className={classes.CardBig__right}>
        <h2>{data?.title}</h2>
        <p>
          {data?.postedBy?.name?.firstName} {data?.postedBy?.name?.lastName} •{" "}
          {moment(data?.createdAt).format("DD MMM, YYYY")}
        </p>
        <h5>
          {htmlToText(data?.content)?.slice(0, 120)}
          {data?.content?.length > 200 && "..."}
        </h5>
      </div>
    </div>
  );
}
